import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#eff6ff' },
  card: { background: '#fff', padding: 40, borderRadius: 16, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', width: '100%', maxWidth: 420 },
  title: { fontSize: 28, fontWeight: 700, color: '#1e3a8a', marginBottom: 8 },
  sub: { color: '#64748b', marginBottom: 28 },
  label: { display: 'block', marginBottom: 6, fontWeight: 600, color: '#374151' },
  input: { width: '100%', padding: '12px 14px', borderRadius: 8, border: '1.5px solid #e2e8f0', fontSize: 16, marginBottom: 18, outline: 'none', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '14px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  error: { color: '#ef4444', marginBottom: 16, fontSize: 14 },
  success: { color: '#16a34a', background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '12px 16px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  link: { textAlign: 'center', marginTop: 20, color: '#64748b' }
};

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.title}>Forgot Password</div>
        <div style={s.sub}>Enter your email and we'll send you a reset link</div>
        {error && <div style={s.error}>{error}</div>}
        {success ? (
          <div style={s.success}>
            Check your email! A password reset link has been sent to <strong>{email}</strong>. It expires in 1 hour.
          </div>
        ) : (
          <form onSubmit={submit}>
            <label style={s.label}>Email</label>
            <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required />
            <button style={s.btn} disabled={loading}>{loading ? 'Sending...' : 'Send Reset Link'}</button>
          </form>
        )}
        <div style={s.link}><Link to="/login">Back to Sign In</Link></div>
      </div>
    </div>
  );
}
